export const taxValue:number = 0.27;